var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"menuItemMobileMenu"},[(_vm.hasHeader)?_c('mobile-menu-section-header',{attrs:{"label":_vm.headerLabel,"labelId":_vm.headerLabelId}}):_vm._e(),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }